/* ==========================================================================
   MAISON NOIR & CO — scroll reveal
   Adds .is-inview to any [.mn-reveal] element as it enters the viewport, so
   custom sections can fade/slide in. Robust & progressive:
   - Marks <html> with .mn-js immediately, so CSS knows JS is alive. Sections
     keep .mn-reveal hidden ONLY when .mn-js is present; with no JS the CSS
     fallback shows everything (see maison-tokens / section stylesheets).
   - Respects prefers-reduced-motion (reveals instantly, no transition).
   - Re-scans after Shopify section re-renders in the theme editor.
   ========================================================================== */
(function () {
  var root = document.documentElement;
  root.classList.add('mn-js');

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(scope) {
    var els = (scope || document).querySelectorAll('.mn-reveal:not(.is-inview)');
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-inview');
  }

  // No IntersectionObserver (old browser) or reduced motion → just show all.
  if (reduce || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.mn-reveal:not(.is-inview)');
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
  }

  function init() {
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-observe when a section is (re)loaded.
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });
})();
